import { apiClient } from '@/services/api/client';
import type { SearchParams, SearchResponse } from './types';

function isWrappedResponse(data: unknown): data is { data: SearchResponse } {
  return (
    typeof data === 'object' &&
    data !== null &&
    'data' in data &&
    typeof (data as Record<string, unknown>)['data'] === 'object'
  );
}

export const searchService = {
  search: async (params: SearchParams) => {
    const { signal, ...queryParams } = params;

    const response = await apiClient.get<SearchResponse>('/search', {
      params: queryParams,
      signal,
    });

    return isWrappedResponse(response.data)
      ? response.data['data']
      : response.data;
  },
};
